/*
 * @Author: Duanjiaojiao
 * @Date: 2022-04-19 20:35:35
 * @LastEditors: Duanjiaojiao
 * @LastEditTime: 2023-03-13 19:30:41
 * @Description: 规范url
 * @FilePath: /BM-Main/src/conf/url.config.js
 * @props:
 */
import { mHost } from './hosts.conf'
import { inPlum } from '@/utils/env'

const bmCommon = `//${mHost}/u/bm_common/`
const bmMain = `//${mHost}/u/bmmain/`
const bmSsr = `//${mHost}/u/node_ssr_bm/`
// const consign = `//${mHost}/u/bm-consign/`
// const consignSsr = `//${mHost}/u/bm-consign-entry/`
// 下单后的页面
const bmCommonUrl = {
  preOrderDetail: `${bmCommon}order/submit-wait?needHideHead=3`, // 预下单订单详情
  orderDetail: `${bmCommon}order/detail?needHideHead=3`, // 订单详情
  qcReportNew: `${bmCommon}order/zj-report-new?needHideHead=3`, // 质检报告new
  userComment: `${bmCommon}auctionroom/comment`, // 评价列表页
  historyEvaluation: `${bmCommon}help/history-evaluation-list`

}

// 转转下单前页面
const bmMainUrl = {
  typeSelect: `${bmMain}helpsale/model-select?needHideHead=3`,
  search: `${bmMain}helpsale/search?needHideHead=3`,
  evaluate: `${bmMain}helpsale/evaluate?needHideHead=3`,
  lotteryOptionsSelect: `${bmMain}new-media/lottery-select?needHideHead=3`,
  lotteryReport: `${bmMain}new-media/lottery-report`,
  recycleCard: `${bmMain}helpsale/recycle-car?needHideHead=3`,
  recycleCardOrder: `${bmMain}helpsale/recycle-car-order?needHideHead=3`,
  mergeOrder: `${bmMain}helpsale/merge-order?needHideHead=3`,
  mine: `${bmMain}help/mine`,
  b2cPrivilegePage: `${bmMain}help/b2c-privilege?needHideHead=3`,
  c2bPrivilegePage: `${bmMain}helpsale/my-privilege`,
  engineerTransfer: `${bmMain}engineer-transfer?needHideHead=3`,
  // 一键上门相关页面
  oneClickD2D: `${bmMain}helpsale/one-click-d2d?needHideHead=3`,
  oneClickD2DSearch: `${bmMain}helpsale/one-click-d2d/search?needHideHead=3`,
  oneClickD2DOrder: `${bmMain}helpsale/one-click-d2d/order?needHideHead=3`,
  oneClickD2DV2: `${bmMain}helpsale/one-click-d2d-v2?needHideHead=3`,
  oneClickD2DV2Selected: `${bmMain}helpsale/one-click-d2d-v2/selected-items?needHideHead=3`
}

const bmSsrUrl = {
  home: `${bmSsr}home?needHideHead=3`
}

// 寄卖下单前页面
// const consignSsrUrl = {}

// 端内原生页
const appUrl = {
  jumpWX: 'zhuanzhuan://jump/core/miniProgram/jump?&platform=wechat&userName=gh_c2980df66965&path=',
  jumpWXSiYu: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/63579adbbec6130063343eab/index.html?magicplatform=zz&needNewWebview=1',
  topicPublish: 'zhuanzhuan://jump/community/publish/jump?from=selfEvaluate&resourceId=1&resourceType=1&topicId=1539173422829928450&topicTitle=%E8%BA%AB%E4%BB%B7%E7%A5%9E%E6%B5%8B'
}

// 魔方页面
const magicUrl = {
  b2cPrivilegeRule: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/64c0e29611004300635d3a35/index.html?magicplatform=common&needNewWebview=1'
}

// 履约上门测的页面
const d2dUrl = {
  d2dArea: `//${mHost}/zlj/jqact/check-offline-address-v3?needHideHead=3`
}

// 平台页面
const platformUrl = {
  feedBack: inPlum ? 'https://m.zhuanzhuan.com/common/uem/index.html#/question-bch' : 'https://m.zhuanzhuan.com/common/uem/index.html#/question-bch?needHideHead=3&wvCornerRadius=32&wvHalfVer=v2&wvHeightRate=0.8',
  userAddressList: 'https://m.zhuanzhuan.com/platform/user_address/address-list?isRecycle=true&needHideHead=3',
  editAddress: 'https://m.zhuanzhuan.com/platform/user_address/edit-address?needHideHead=3&isRecycle=true&scene=shangMen'
}

const tradeUrl = {
  orderListSell: `//${mHost}/trade/order_list_v3/sell.html?needHideHead=3&hiddenProgress=1`
}

export {
  bmCommonUrl,
  appUrl,
  bmMainUrl,
  bmSsrUrl,
  d2dUrl,
  magicUrl,
  platformUrl,
  tradeUrl
}
